/*eslint-disable*/
import React from 'react';

const Social = () => (
  <div className="home_social">
    <a href="https://www.linkedin.com/in/basit-ali-jobs" className="home_social-icon" target="_blank" rel="noreferrer">
      <i className="uil uil-linkedin-alt" />
    </a>
    <a href="https://github.com/basitali111" className="home_social-icon" target="_blank" rel="noreferrer">
      <i className="uil uil-github-alt" />
    </a>

    <a href="https://api.whatsapp.com/send?phone=+923094225432&text=Hello, more information!" className="home_social-icon" target="_blank" rel="noreferrer">
      <i className="uil uil-whatsapp" />
    </a>
    <a href="https://medium.com/@allahbadshah148" className="home_social-icon" target="_blank" rel="noreferrer">
      <i className="uil uil-medium-m" />
    </a>
  </div>
);

export default Social;
